var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simplify__nav"},[_c('section',{staticClass:"stickyPanel"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }